"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTokenURIDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const BaseTokenURIDialogForm = () => {
    return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "baseTokenURI", required: true });
};
exports.BaseTokenURIDialogForm = BaseTokenURIDialogForm;
//# sourceMappingURL=index.js.map